
import {
    defineComponent,
    ref,
    toRefs,
    PropType,
    computed
} from 'vue';

import {
    vLoading,
    ElTooltip,
    ElButton,
    ElMessage
} from 'element-plus';
import { Delete } from '@element-plus/icons-vue';
import { uploadArticle } from '@/services';

export default defineComponent({
    directives: {
        vLoading
    },
    components: {
        ElTooltip,
        ElButton
    },
    props: {
        recordId: {
            type: String,
            default: ''
        },
        allowedExt: {
            type: Array as PropType<string[]>,
            default: () => {
                return ['image/png', 'image/jpeg'];
            }
        },
        modelValue: {
            type: String,
            required: true
        }
    },
    emits: {
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        'update:modelValue': (val:string) => true
    },
    setup (props, { emit }) {
        const {
            modelValue,
            allowedExt,
            recordId
        } = toRefs(props);
        const loading = ref(false);
        const isDisabled = computed(() => !!modelValue.value);

        const myValue = computed({
            get: () => modelValue.value,
            set: (val) => emit('update:modelValue', val)
        });

        const handleRemovePic = () => {
            myValue.value = '';
        };

        const selectFile = (e:Event) => {
            const selectedFiels = (e.target as HTMLInputElement).files;
            if (!selectedFiels) {
                return;
            }
            for (let i = 0; i < selectedFiels.length; i++) {
                if (
                    !allowedExt.value.find((val) => {
                        return val === selectedFiels[i].type;
                    })
                ) {
                    ElMessage.error('文件格式不正确');
                    continue;
                }
                loading.value = false;
                const formdata = new FormData();
                formdata.append('image', selectedFiels[i]);
                formdata.append('article_id', recordId.value);
                uploadArticle(formdata).then((json) => {
                    myValue.value = json.data.url;
                    ElMessage.success('上传成功');
                }).catch((json) => {
                    ElMessage.error(json.data.msg);
                }).finally(() => {
                    loading.value = false;
                });

                break;
            }
        };

        return {
            loading,
            isDisabled,
            handleRemovePic,
            selectFile,
            Delete
        };
    }
});
